var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ExpensesTabs',{attrs:{"tab":'Finance'},on:{"tab":function($event){return _vm.onTabChange($event)}}}),_c('ListFinance',{attrs:{"color":_vm.color,"currencies":_vm.currencies},on:{"row-click":function($event){return _vm.onRowClick($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }